// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + "svber" + "." + "8a715156" + ".chunk.css");